import { gql } from '@apollo/client';

export const GET_MAIN_CATEGORY_AI = gql`
  query GetMainCategoryAI($recipe: String!, $brandKey: BrandKey!) {
    getMainCategoryAI(recipe: $recipe, brandKey: $brandKey) {
      category {
        id
        title
      }
    }
  }
`;
